// extracted by mini-css-extract-plugin
export default {"shipping":"Kh-z","header":"Lh-z","adjustMarginAndPaddingNewDesign":"Mh-z"};